// static/js/components/ui/GuidancePromptsButton.jsx

import React from 'react';
import { Settings } from 'lucide-react';

const GuidancePromptsButton = ({ onClick, isActive }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-4 py-2 rounded-full 
        transition-colors ${
          isActive 
            ? 'bg-primary-button text-black' 
            : 'bg-primary-700/10 text-primary-text hover:bg-primary-700/20'
        }`}
      title="AI Guidance Prompts"
    >
      <Settings size={16} />
      <span className="text-sm">AI Guidance</span>
    </button>
  );
};

export default GuidancePromptsButton;